module.exports = __webpack_public_path__ + "img/Differentiation-PDAC_GSE202740.40c9f011.png";